/**
Project: Voice Panel (c)
Title: Signin Silent Start 
Description: Component for Authorization check for teams sign in
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { AppURLProps } from "../settings/app-urls";

class SigninSilentStart extends Component {
  componentDidMount() {
    this.interactive();
  }

  interactive = () => {
    const azureActiveDirectoryAppId =
      process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_ID;
    microsoftTeams.initialize();

    microsoftTeams.getContext(function (context) {
      let state = _guid();
      let queryParams = {
        client_id: azureActiveDirectoryAppId,
        response_type: "id_token token",
        response_mode: "fragment",
        resource: "https://admingb1.online.lync.com/OcsPowershellOAuth",
        redirect_uri: window.location.origin + AppURLProps.signinSilentEnd,
        nonce: _guid(),
        state: state,
        login_hint: context.loginHint,
      };

      let authorizeEndpoint = `https://login.microsoftonline.com/${
        context.tid
      }/oauth2/authorize?${toQueryString(queryParams)}`;
      window.location.assign(authorizeEndpoint);
    });

    function toQueryString(queryParams) {
      let encodedQueryParams = [];
      for (let key in queryParams) {
        encodedQueryParams.push(
          key + "=" + encodeURIComponent(queryParams[key])
        );
      }
      return encodedQueryParams.join("&");
    }

    function _decimalToHex(number) {
      var hex = number.toString(16);
      while (hex.length < 2) {
        hex = "0" + hex;
      }
      return hex;
    }

    function _guid() {
      var cryptoObj = window.crypto || window.msCrypto; // for IE 11
      if (cryptoObj && cryptoObj.getRandomValues) {
        var buffer = new Uint8Array(16);
        cryptoObj.getRandomValues(buffer);
        buffer[6] |= 0x40;
        buffer[6] &= 0x4f;
        buffer[8] |= 0x80;
        buffer[8] &= 0xbf;
        return (
          _decimalToHex(buffer[0]) +
          _decimalToHex(buffer[1]) +
          _decimalToHex(buffer[2]) +
          _decimalToHex(buffer[3]) +
          "-" +
          _decimalToHex(buffer[4]) +
          _decimalToHex(buffer[5]) +
          "-" +
          _decimalToHex(buffer[6]) +
          _decimalToHex(buffer[7]) +
          "-" +
          _decimalToHex(buffer[8]) +
          _decimalToHex(buffer[9]) +
          "-" +
          _decimalToHex(buffer[10]) +
          _decimalToHex(buffer[11]) +
          _decimalToHex(buffer[12]) +
          _decimalToHex(buffer[13]) +
          _decimalToHex(buffer[14]) +
          _decimalToHex(buffer[15])
        );
      } else {
        var guidHolder = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
        var hex = "0123456789abcdef";
        var r = 0;
        var guidResponse = "";
        for (var i = 0; i < 36; i++) {
          if (guidHolder[i] !== "-" && guidHolder[i] !== "4") {
            r = (Math.random() * 16) | 0;
          }
          if (guidHolder[i] === "x") {
            guidResponse += hex[r];
          } else if (guidHolder[i] === "y") {
            r &= 0x3;
            r |= 0x8;
            guidResponse += hex[r];
          } else {
            guidResponse += guidHolder[i];
          }
        }
        return guidResponse;
      }
    }
  };

  render() {
    return <></>;
  }
}

export default SigninSilentStart;
